/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/loan_in'
export default icon
